import { render, staticRenderFns } from "./FileDetails.vue?vue&type=template&id=501d6e98&scoped=true"
import script from "./FileDetails.vue?vue&type=script&lang=js"
export * from "./FileDetails.vue?vue&type=script&lang=js"
import style0 from "./FileDetails.vue?vue&type=style&index=0&id=501d6e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501d6e98",
  null
  
)

export default component.exports